import React, { useState } from 'react';
import { Button, Modal } from 'antd';

const ConfirmModal = ({ title = "Save Changes?", loading = false, message = "Are you sure?", open, handleCloseModal, handleOk, handleCancel, okText = "Save", cancelText = "Cancel" }) => {
  return (
    <Modal
      title={title}
      open={open}
      onOk={handleOk}
      onCancel={handleCloseModal}
      bodyStyle={{ padding: '12px 24px' }}
      className="custom-modal"
      footer={[
        <Button key="back" className='btn-tertiary' onClick={handleCancel}>
          {cancelText}
        </Button>,
        <Button key="submit" loading={loading}  type='danger' className='btn-primary' onClick={handleOk}>
          {okText}
        </Button>,
      ]}>
      <p>{message}</p>
    </Modal>
  );
};
export default ConfirmModal;